<template>
    <main-layout>
        <template #breadcrumbs>
            <span class="union-icon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo-chart-title">
                <inertia-link :href="route('home')">
                    <span class="repo-text">Repositories</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <inertia-link :href="route('repository.view', {team: team})">
                    <span class="repo-text">{{ team.slug }}</span>
                </inertia-link>
                <span class="d-line">/ </span>
                Helm Repository Settings
            </span>
        </template>
        <template #pageTitle>
            <h2 class="mb-1">{{team.slug}} repository settings</h2>
            <span class="sm-text">Manage your repository here</span>
        </template>
        <template #rightSidebar>
            <repository-sidebar :slug="team.slug" :show-repo-add="false"/>
        </template>

        <div v-if="false">
            <div class="title-col2 text-left">
                <h2>Deploy Tokens</h2>
            </div>
            <div class="table-style">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col">Username</th>
                            <th scope="col">Created Date</th>
                            <th scope="col">Expires at</th>
                            <th scope="col">Expire token</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="td-blank"></td>
                            <td class="td-blank"></td>
                            <td class="td-blank"></td>
                            <td class="td-blank"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="btn-col mt-3 pt-0 pt-md-2">
                <inertia-link :href="route('repository-settings.deploy-token', {team: team})" as="button"
                              class="btn btn-style btn-primary">
                    <span>Create Deploy Token</span>
                </inertia-link>
            </div>
        </div>
        <div class="panel-wrap">
            <div class="title-col2 text-left">
                <h2>Advanced</h2>
            </div>
            <div class="panel-body" v-if="false">
                <div class="row g-2 align-items-center">
                    <div class="col-md">
                        <div class="panel-style">
                            <h4>Change ownership</h4>
                            <p>Changing ownership is a dangerous operation. You won’t have access to this repository
                                after new owner accepts your invitation</p>
                        </div>
                    </div>
                    <div class="col-md-auto">
                        <div class="panel-btn">
                            <button type="button" name="button" class="btn btn-style btn-primary"
                                    @click="changeOwnershipShow()"><span>Change Owner</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-body" v-if="false">
                <div class="row g-2 align-items-center">
                    <div class="col-md">
                        <div class="panel-style">
                            <h4>Rename repository</h4>
                            <p>
                                <Renam></Renam>
                                ing chart is a dangerous operation. Helm charts installed before renaming will
                                not switch to the new location automatically. It is recommended to create a copy of
                                a chart with a new name and keep old one archived
                            </p>
                        </div>
                    </div>
                    <div class="col-md-auto">
                        <div class="panel-btn">
                            <button type="button" name="button" class="btn btn-style btn-primary"
                                    @click="renameRepositoryShow()"><span>Rename Repository</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-body" v-if="false">
                <div class="row g-2 align-items-center">
                    <div class="col-md">
                        <div class="panel-style">
                            <h4>Archive repository</h4>
                            <p>Chart will remain available but readonly. No new versions of the chart will be
                                published. Integrations with the git repository will be suspended.</p>
                        </div>
                    </div>
                    <div class="col-md-auto">
                        <div class="panel-btn">
                            <button type="button" name="button" class="btn btn-style btn-primary"
                                    @click="confirmArchiveRepository(team)"><span>Archive repository</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <div class="row g-2 align-items-center">
                    <div class="col-md">
                        <div class="panel-style">
                            <h4>Delete repository</h4>
                            <p>This operation is irreversible. The repository will become unavailable immediately after
                                deletion. You may reuse the same chart name in the future.</p>
                        </div>
                    </div>
                    <div class="col-md-auto">
                        <div class="panel-btn">
                            <button type="button" name="button" class="btn btn-style btn-danger"
                                    @click="confirmDeleteRepository(team)"><span>Delete repository</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Change ownership -->
        <jet-dialog-modal :show="ownershipBeingChanged" @close="closeModal">
            <template #title>
                Change ownership
            </template>

            <template #content>
                <p>Are you sure you want to change ownership?</p>

                <div class="mt-4">
                    <jet-input type="email" placeholder="Email"
                               v-model="formOwner.newOwnerEmail"
                               @keyup.enter.native="changeOwnership"/>

                    <!-- <jet-input-error :message="form.errors.password" class="mt-2" /> -->
                </div>
            </template>

            <template #footer>
                <jet-secondary-button @click.native="closeModal">
                    <span>Nevermind</span>
                </jet-secondary-button>

                <jet-danger-button class="ml-2" @click.native="changeOwnership"
                                   :class="{ 'opacity-25': formOwner.processing }" :disabled="formOwner.processing">
                    <span>Change ownership</span>
                </jet-danger-button>
            </template>
        </jet-dialog-modal>
        <!-- Rename repository -->
        <jet-dialog-modal :show="repositoryBeingRenamed" @close="closeModal">
            <template #title>
                Rename repository
            </template>

            <template #content>
                <p>Are you sure you want to rename repository?</p>

                <div class="mt-4">
                    <jet-input type="text" placeholder="New repository name"
                               v-model="form.repositoryName"
                               @keyup.enter.native="renameRepository"/>

                    <!-- <jet-input-error :message="form.errors.password" class="mt-2" /> -->
                </div>
            </template>

            <template #footer>
                <jet-secondary-button @click.native="closeModal">
                    <span>Nevermind</span>
                </jet-secondary-button>

                <jet-danger-button class="ml-2" @click.native="renameRepository"
                                   :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    <span>Rename repository</span>
                </jet-danger-button>
            </template>
        </jet-dialog-modal>
        <!-- Archive repository -->
        <jet-confirmation-modal :show="repositoryBeingArchived" @close="repositoryBeingArchived = null">
            <template #title>
                Archive repository
            </template>

            <template #content>
                Are you sure you would like to archive repository?
            </template>

            <template #footer>
                <jet-secondary-button @click.native="repositoryBeingArchived = null">
                    Nevermind
                </jet-secondary-button>

                <jet-danger-button class="ml-2" @click.native="archiveRepository">
                    Archive
                </jet-danger-button>
            </template>
        </jet-confirmation-modal>
        <!-- Delete repositiry -->
        <jet-confirmation-modal :show="repositoryBeingDeleted" @close="repositoryBeingDeleted = null">
            <template #title>
                Delete Repository
            </template>

            <template #content>
                Are you sure you would like to delete repository?
            </template>

            <template #footer>
                <jet-secondary-button @click.native="repositoryBeingDeleted = null">
                    Nevermind
                </jet-secondary-button>

                <jet-danger-button class="ml-2" @click.native="deleteRepository"
                                   :class="{ 'opacity-25': deleteRepositoryForm.processing }"
                                   :disabled="deleteRepositoryForm.processing">
                    Delete
                </jet-danger-button>
            </template>
        </jet-confirmation-modal>
    </main-layout>
</template>

<script>
    import MainLayout from "@/Layouts/MainLayout";
    import Templates from "@/Pages/HelmChart/Templates";
    import RepositorySidebar from "@/Pages/Repository/RepositorySidebar";
    import UpdateTeamNameForm from "@/Pages/Teams/UpdateTeamNameForm";
    import DeleteTeamForm from "@/Pages/Teams/DeleteTeamForm";
    import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
    import JetDangerButton from '@/Jetstream/DangerButton';
    import JetSecondaryButton from '@/Jetstream/SecondaryButton';
    import JetDialogModal from '@/Jetstream/DialogModal';
    import JetInput from '@/Jetstream/Input';
    import JetInputError from '@/Jetstream/InputError';

    export default {
        name: "Settings",
        components: {
            DeleteTeamForm,
            UpdateTeamNameForm,
            RepositorySidebar,
            Templates,
            MainLayout,
            JetConfirmationModal,
            JetDangerButton,
            JetSecondaryButton,
            JetDialogModal,
            JetInput,
            JetInputError
        },
        props: ['team', 'permissions'],
        data() {
            return {
                repositoryBeingDeleted: null,
                deleteRepositoryForm: this.$inertia.form(),
                repositoryBeingArchived: null,
                repositoryBeingRenamed: false,
                form: this.$inertia.form({
                    repositoryName: '',
                }),
                formOwner: this.$inertia.form({
                    newOwnerEmail: '',
                }),
                ownershipBeingChanged: false,
            }
        },
        methods: {
            changeOwnershipShow() {
                this.ownershipBeingChanged = true;
            },
            changeOwnership() {

            },
            renameRepositoryShow() {
                this.repositoryBeingRenamed = true;
            },
            renameRepository() {

            },
            closeModal() {
                this.repositoryBeingRenamed = false;
                this.ownershipBeingChanged = false;

                this.form.reset()
            },
            confirmDeleteRepository(team) {
                this.repositoryBeingDeleted = team
            },
            deleteRepository() {
                this.deleteRepositoryForm.delete(route('teams.destroy', this.team), {
                    errorBag: 'deleteTeam'
                })
            },
            confirmArchiveRepository(team) {
                this.repositoryBeingArchived = team
            },
            archiveRepository() {

            }
        },
    }
</script>

<style scoped>

</style>
